import { post, queryKeys, SignUpUrl } from '@mobi/account/Utils'
import { useMutation } from '@tanstack/react-query'

export type TypeSignupApplication = {
  firstName: string
  middleName: string
  surname: string
  birthdate: string
  email: string
  mobileNumber: string
  applicationReferenceNumber?: number
  enquiryId?: string
  residentialAddress: TypeSignUpApplicationAddress
  previousAddress?: TypeSignUpApplicationAddress
  marketingOptInIndicator: boolean
}

export type TypeSignUpApplicationRequest = TypeSignupApplication & {
  affiliateMarketingId?: string
  locationId?: string
  venueId?: string
}

export type TypeSignUpApplicationAddress = {
  unitNumber?: string
  streetNumber?: string
  streetName?: string
  streetType?: string
  suburb?: string
  postCode?: string
  state?: string
  moniker?: string
}

export type TypeSignUpApplicationResponse = {
  applicationReferenceNumber: number
  enquiryId: string
  duplicateExists: boolean
  isDuplicateClosed: boolean
  isVerified: boolean
  unVerifiedReason: string
  potentialFraudMatch: boolean
  potentialSanctionedMatch: boolean
}

export const useSignUpApplication = () => {
  const { mutate: saveSignUpApplication, status: saveSignUpApplicationStatus } = useMutation({
    mutationFn: (
      applicationDetails: TypeSignUpApplicationRequest
    ): Promise<TypeSignUpApplicationResponse> =>
      post(SignUpUrl.signUpApplication, applicationDetails),
    mutationKey: [queryKeys.signupCreateSignUpApplication],
  })
  return { saveSignUpApplication, saveSignUpApplicationStatus }
}
